import { combineReducers } from 'redux';

import departamentoSelecionado from './departamento-selecionado';
import websocketConnection from './websocket-connection';
import produtoSelecionado from './produto-selecionado';
import pedidoSelecionado from './pedido-selecionado';
import menuAtivo from './menu-ativo';
import section from './config-section.js';
import produtos from './produtos';
import pedidos from './pedidos';
import toast from './toast';
import user from './user';

export default combineReducers({
    departamentoSelecionado,
    websocketConnection,
    produtoSelecionado,
    pedidoSelecionado,
    menuAtivo,
    section,
    produtos,
    pedidos,
    toast,
    user
});
